<template>
  <div class="order" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="orderState">
      <div class="meetingRoom">
        <div class="blank"></div>
        <div class="meeting">
          <div class="meetingName">
            <div class="blankTwo"></div>
            <div class="nameText">{{ this.meetingName }}</div>
            <div class="button">
              <div class="orderButton" @click="orderHandle" v-if="apkStatus">
                <div class="orderText">预约</div>
              </div>
              <div class="signButton" @click="signHandle" v-if="showSign">
                <div class="signText">签到</div>
              </div>
            </div>
          </div>
          <div class="line">
            <img src="../assets/line.png" alt="" />
          </div>
          <div class="meetingIntroduced">
            <!-- <div class="unused" v-if="this.meetStatus == 1">当前会议室正在使用</div> -->
            <div
              class="unused"
              v-if="this.meetStatus == 3 || this.dataList.length === 0"
            >
              当前会议室未使用
            </div>
            <!-- <div class="begin" v-if="this.meetStatus == 1">正在使用的会议</div> -->
            <div
              class="begin"
              v-if="this.meetStatus == 3 && dataList.length > 0"
            >
              即将开始的会议
            </div>
            <div class="begin" v-if="dataList.length > 0">
              {{ this.startTime | dateFmt("HH:mm") }} -
              {{ this.endTime | dateFmt("HH:mm") }}
            </div>
            <div class="begin" v-if="dataList.length > 0">
              会议主题：{{ this.theme }}
            </div>
            <div class="countdown" v-if="dataList.length > 0">
              <!-- <span v-if="this.meetStatus == 1">距离结束时间：{{ this.hms }}</span> -->
              <span v-if="this.meetStatus == 3"
                >距离开始时间：{{ this.hms }}</span
              >
            </div>
          </div>
        </div>
        <div class="meetingList">
          <swiper
            class="swiper-container"
            :options="swiperOption"
            ref="mySwiper"
            style="width:100%"
          >
            <swiper-slide v-for="(item, key) in startForm()" :key="key">
              <div class="list">
                <div class="listTime">
                  <span
                    >{{ item.startTime | dateFmt("HH:mm") }} -
                    {{ item.endTime | dateFmt("HH:mm") }}</span
                  >
                </div>
                <div class="listInfo">会议主题：{{ item.theme }}</div>
                <div class="listInfo">预约人：{{ item.appointmenter }}</div>
                <div class="listInfo">部门：{{ item.department }}</div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { allLists, releases, getDatas, getMeetModel } from "@/utils/request";
import HomeHeader from "./header";
import moment, { now } from "moment";
export default {
  components: {
    HomeHeader
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 10
        // slidesPerGroup: 2,
        // loopFillGroupWithBlank: true
      },
      meetingId: "",
      dataList: [],
      hms: "",
      meetStatus: "", //会议状态 1正在使用  3未使用
      startTime: "",
      endTime: "",
      theme: "",
      start: "",
      end: "",
      equipmentName: "",
      id: "",
      flag: "",
      showSign: "",
      startTime2: "",
      Clock: null,
      timer: null,
      meetingName: "",
      fonts: "",
      bgUrl:'',
      apkStatus: ''
    };
  },
  mounted() {
    this.bgUrl = localStorage.getItem('bgUrl')
    console.log(this.bgUrl)
    this.apkStatus = localStorage.getItem('apkStatus') === '1' ? true:false
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;

    this.timer = setInterval(() => {
      this.allLists();
      // this.getMeetModels();
    }, 10000);
    this.allLists();
    this.initDaojishi();
    this.releases();
  },
  beforeDestroy() {
    if (this.Clock) {
      clearInterval(this.Clock); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fonts = res.data.fontStyle;
        }
      });
    },
    // 点击跳转
    orderHandle() {
      this.$router.push({
        path: "/appoint",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          meetingName: this.meetingName
        }
      });
    },
    signHandle() {
      localStorage.setItem("isAuto", "no");
      this.$router.push({
        path: "/register",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          meetingName: this.name,
          id: this.id,
          theme: this.theme,
          startTime: this.startTime,
          endTime: this.endTime
        }
      });
    },
    // 会议室信息列表
    allLists() {
      let params = {
        meetingId: this.meetingId
      };
      allLists(params).then(res => {
        if (res.code == 0) {
          this.meetStatus = res.data.status[0].meetStatus;
          this.flag = res.data.flag;
          if (res.data.pageInfoList.list.length > 0) {
            this.showSign = true;
            this.dataList = res.data.pageInfoList.list;
            this.startTime = res.data.pageInfoList.list[0].startTime;
            this.endTime = res.data.pageInfoList.list[0].endTime;
            this.theme = res.data.pageInfoList.list[0].theme;
            this.id = res.data.pageInfoList.list[0].id; //当前即将开始会议的id
          } else {
            this.showSign = false;
          }
          if (this.meetStatus == 1 && res.data.pageInfoList.list.length > 0) {
            this.$router.push({
              path: "/advertising",
              query: {
                equipmentName: this.equipmentName,
                meetingId: this.meetingId,
                meetingName: this.meetingName,
                id: this.id,
                theme: this.theme,
                startTime: this.startTime,
                endTime: this.endTime
              }
            });
          } else {
            // const curdatetime = new Date().getTime();
            // const curstarttime = new Date(this.startTime).getTime();
            // if (curstarttime - curdatetime > 30 * 60 * 1000) {
            //   this.$router.push({
            //     path: "/canBusiness",
            //     query: {
            //       equipmentName: this.equipmentName,
            //       meetingId: this.meetingId,
            //       meetingName: this.meetingName
            //     }
            //   });
            // }
          }
          // let newDate = new Date()
          this.startTime2 = new Date(
            new Date(this.startTime).getTime() - 600000
          );
        }
      });
    },
    // 倒计时
    initDaojishi() {
      let _this = this;
      this.Clock = window.setInterval(() => {
        if (_this.meetStatus == 1) {
          const curdate = new Date().getTime();
          const meetingEndTimeseconds = new Date(_this.endTime).getTime();
          let msec = Math.abs(meetingEndTimeseconds - curdate);
          let hr =
            parseInt(msec / 1000 / 60 / 60) >= 10
              ? parseInt(msec / 1000 / 60 / 60)
              : "0" + parseInt(msec / 1000 / 60 / 60);
          let min =
            parseInt((msec / 1000 / 60) % 60) >= 10
              ? parseInt((msec / 1000 / 60) % 60)
              : "0" + parseInt((msec / 1000 / 60) % 60);
          let sec =
            parseInt((msec / 1000) % 60) >= 10
              ? parseInt((msec / 1000) % 60)
              : "0" + parseInt((msec / 1000) % 60);
          if (meetingEndTimeseconds < curdate) {
            _this.hms = hr + ":" + min + ":" + sec;
          } else {
            _this.hms = hr + ":" + min + ":" + sec;
          }
        } else {
          const curdate = new Date().getTime(); //当前时间
          const meetingStartTimeseconds = new Date(this.startTime).getTime(); //开始时间戳
          let msec = Math.abs(meetingStartTimeseconds - curdate);
          let hr =
            parseInt(msec / 1000 / 60 / 60) >= 10
              ? parseInt(msec / 1000 / 60 / 60)
              : "0" + parseInt(msec / 1000 / 60 / 60);
          let min =
            parseInt((msec / 1000 / 60) % 60) >= 10
              ? parseInt((msec / 1000 / 60) % 60)
              : "0" + parseInt((msec / 1000 / 60) % 60);
          let sec =
            parseInt((msec / 1000) % 60) >= 10
              ? parseInt((msec / 1000) % 60)
              : "0" + parseInt((msec / 1000) % 60);
          if (meetingStartTimeseconds < curdate) {
            //会议还未开始
            _this.hms = hr + ":" + min + ":" + sec;
          } else {
            //会议还有十分钟就开始了
            _this.hms = hr + ":" + min + ":" + sec;
            if (meetingStartTimeseconds - curdate < 30 * 60 * 1000) {
              clearInterval(_this.Clock);
              localStorage.setItem("isAuto", "yes");
              _this.$router.push({
                path: "/register",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.meetingName,
                  homeTo: true,
                  id: this.id,
                  theme: this.theme,
                  startTime: this.startTime,
                  endTime: this.endTime
                }
              });
            }
          }
        }
      });
    },
    // 循环从下标1开始
    startForm() {
      return this.dataList.slice(1);
    },

    // 广告信息
    releases() {
      let params = {
        meetingId: this.meetingId
      };
      releases(params).then(res => {
        if (res.code == 0 && res.data.length > 0) {
          this.start = res.data[0].startTime;
          this.end = res.data[0].endTime;
        }
      });
    },
    changeF(font) {
      this.fonts = font;
    }
  },
  watch: {
    startTime: function(value) {
      value = this.startTime2;
      console.log(value);
    }
  }
};
</script>

<style lang="less" scoped>
.order {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .time {
    width: 100%;
    height: 10%;
    background-color: rgba(76, 95, 162, 0.4);
    display: flex;
    p {
      width: 95%;
      text-align: center;
      color: #fff;
      line-height: 110px;
      font-size: 34px;
    }
    .icon {
      width: 5%;
      height: 100%;
      background: url(../assets/person.png) no-repeat;
      margin-top: 30px;
    }
  }
  .orderState {
    width: 100%;
    height: 90%;
    display: flex;
    .meetingRoom {
      width: 100%;
      height: 100%;
      .blank {
        width: 100%;
        height: 10%;
      }
      .meeting {
        width: 100%;
        height: 55%;
        display: flex;
        .meetingName {
          width: 50%;
          height: 90%;
          .blankTwo {
            width: 100%;
            height: 16%;
          }
          .nameText {
            width: 100%;
            min-height: 42%;
            font-size: 128px;
            color: #fff;
            text-align: center;
            letter-spacing: 19px;
          }
          .button {
            width: 60%;
            height: 50%;
            display: flex;
            margin: 0 auto;
            .orderButton {
              width: 100%;
              height: 100%;
              background: url(../assets/qiandao.png) no-repeat;
              background-position: center center;
              // position: relative;
              // left: 9%;
              .orderText {
                // width: 60%;
                // text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                font-size: 49px;
                font-family: SimHei;
                font-weight: bold;
                color: #ffffff;
                background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                line-height: 168px;
              }
            }
            .signButton {
              width: 100%;
              height: 100%;
              background: url(../assets/qiandao.png) no-repeat;
              background-position: center center;
              // position: relative;
              // left: 9%;
              .signText {
                // width: 60%;
                // text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                font-size: 49px;
                font-family: SimHei;
                font-weight: bold;
                color: #ffffff;
                background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                line-height: 168px;
              }
            }
          }
        }
        .line {
          width: 6%;
        }
        .meetingIntroduced {
          width: 44%;
          height: 75%;
          .unused {
            width: 100%;
            height: 30%;
            text-align: left;
            font-size: 56px;
            font-family: SimHei;
            font-weight: bold;
            letter-spacing: 6px;
            color: #8ae9c5;
            background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .begin {
            width: 100%;
            height: 25%;
            font-size: 36px;
            font-family: SimHei;
            text-align: left;
            color: #ffffff;
            font-weight: bold;
            letter-spacing: 6px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .countdown {
            // width: 58%;
            // height: 18%;
            display: inline-block;
            padding: 0 5%;
            background-color: rgba(255, 255, 255, 0.2);
            text-align: center;
            span {
              font-size: 33px;
              font-family: SimHei;
              font-weight: bold;
              color: #ffb668;
              line-height: 75px;
            }
          }
        }
      }
      .meetingList {
        width: 100%;
        height: 35%;
        display: flex;
        .list {
          width: 100%;
          height: 100%;
          background: url(../assets/msg-bg.png) no-repeat;
          margin: 40px;
          text-align: center;
          .listTime {
            width: 82%;
            height: 28%;
            span {
              width: 82%;
              font-size: 30px;
              color: #ffb668;
              opacity: 0.7;
              display: inline-block;
              line-height: 100px;
              text-align: left;
            }
          }
          .listLine {
            border: 1px solid #fff;
            opacity: 0.5;
          }
          .listInfo {
            width: 75%;
            height: 13%;
            font-size: 24px;
            color: #ffffff;
            font-family: SimHei;
            font-weight: 400;
            text-align: left;
            margin-left: 35px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue